__turbopack_context__.v({
  "button": "FeedbackForm-module-scss-module__83b82q__button",
  "buttonContainer": "FeedbackForm-module-scss-module__83b82q__buttonContainer",
  "button_close": "FeedbackForm-module-scss-module__83b82q__button_close",
  "button_sent": "FeedbackForm-module-scss-module__83b82q__button_sent",
  "button_text": "FeedbackForm-module-scss-module__83b82q__button_text",
  "charCount": "FeedbackForm-module-scss-module__83b82q__charCount",
  "fieldError": "FeedbackForm-module-scss-module__83b82q__fieldError",
  "form": "FeedbackForm-module-scss-module__83b82q__form",
  "formHeader": "FeedbackForm-module-scss-module__83b82q__formHeader",
  "formSubtitle": "FeedbackForm-module-scss-module__83b82q__formSubtitle",
  "formTitle": "FeedbackForm-module-scss-module__83b82q__formTitle",
  "formWrapper": "FeedbackForm-module-scss-module__83b82q__formWrapper",
  "form_field": "FeedbackForm-module-scss-module__83b82q__form_field",
  "form_row": "FeedbackForm-module-scss-module__83b82q__form_row",
  "input": "FeedbackForm-module-scss-module__83b82q__input",
  "inputWrapper": "FeedbackForm-module-scss-module__83b82q__inputWrapper",
  "inputWrapper_error": "FeedbackForm-module-scss-module__83b82q__inputWrapper_error",
  "label": "FeedbackForm-module-scss-module__83b82q__label",
  "message": "FeedbackForm-module-scss-module__83b82q__message",
  "message_error": "FeedbackForm-module-scss-module__83b82q__message_error",
  "message_icon": "FeedbackForm-module-scss-module__83b82q__message_icon",
  "message_success": "FeedbackForm-module-scss-module__83b82q__message_success",
  "optional": "FeedbackForm-module-scss-module__83b82q__optional",
  "required": "FeedbackForm-module-scss-module__83b82q__required",
  "slideDown": "FeedbackForm-module-scss-module__83b82q__slideDown",
  "spin": "FeedbackForm-module-scss-module__83b82q__spin",
  "spinner": "FeedbackForm-module-scss-module__83b82q__spinner",
  "textarea": "FeedbackForm-module-scss-module__83b82q__textarea",
});
